/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bindMethods from 'auto-bind';

import { createHyperCubeDefForField, getQlikApp } from '../../../utils/qlik';
import { getQlikAppId } from '../../../state/selectors/getQlikAppId';
import { addGamesData } from '../../../state/games';
import { FOOTBALL_GAMES_ABBR_WITH_DATE } from '../../../constants/fields';
import { getGamesValue } from '../../../state/selectors/getFilterValue';
import { addGame, removeGame, removeAllGames } from '../../../state/teamSeasonGameSelection'; // games selection tracking in redux
import { sortGamesList } from '../../../utils/sorting';
import { selectGames, clearGamesField } from '../../../utils/qlikSelectValue'; // apply/clear selection in qlik
import { defaultStyle, selectedStyle } from '../../../constants/gamefilters';

class GameFilter extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);

    this.hyperCubeDef = createHyperCubeDefForField(FOOTBALL_GAMES_ABBR_WITH_DATE);
  }

  componentDidMount() {
    const {
      qlikAppId,
      teamSeasonGameSelection: { games },
    } = this.props;

    if (qlikAppId) {
      // If there're previous selected games, retain selection.
      // Otherwise, re-fetch updated game list.
      if (games.length > 0) {
        return;
      }

      getQlikApp(qlikAppId).then((app) => {
        this.getGamesData(app);
      });
    }
  }

  async componentDidUpdate(prevProps) {
    const { qlikAppId, teamSeasonGameSelection } = this.props;
    const currentSelection = teamSeasonGameSelection;
    const previousSelection = prevProps.teamSeasonGameSelection;

    if (qlikAppId) {
      if (
        previousSelection.team !== currentSelection.team
        || previousSelection.season !== currentSelection.season
      ) {
        getQlikApp(qlikAppId).then((app) => {
          this.getGamesData(app);
        });
      }
      if (previousSelection.games !== currentSelection.games) {
        getQlikApp(qlikAppId).then((app) => {
          clearGamesField(app);
          selectGames(app, currentSelection.games);
        });
      }
    }
  }

  getGamesData(app) {
    const { addGamesData, removeAllGames } = this.props;
    removeAllGames();
    clearGamesField(app);

    app.createCube(this.hyperCubeDef).then((results) => {
      let gameList = results.layout.qHyperCube.qDataPages[0].qMatrix.map(x => x[0].qText);
      gameList = sortGamesList(gameList);
      addGamesData(gameList);
    });
  }

  handleClick(game) {
    const { getGamesValue: games, addGame, removeGame } = this.props;

    if (games.includes(game)) {
      removeGame([game]);
    } else {
      addGame([game]);
    }
  }

  isSelected(game) {
    const { getGamesValue: games } = this.props;
    if (games.includes(game)) {
      return true;
    }
    return false;
  }

  render() {
    const { games } = this.props;
    return (
      <ul id="Sidebar.Filters.Games">
        {games.map(game => (
          <li
            key={game}
            id={`Sidebar.Filters.Games.${game.replace(/\s+/g, '-')}`}
            style={this.isSelected(game) ? selectedStyle : defaultStyle}
            onClick={() => this.handleClick(game)}
          >
            {game}
          </li>
        ))}
      </ul>
    );
  }
}

GameFilter.propTypes = {
  qlikAppId: PropTypes.string.isRequired, // supplied from Redux
  games: PropTypes.array.isRequired, // supplied from Redux
  getGamesValue: PropTypes.array.isRequired, // supplied from Redux
  addGamesData: PropTypes.func.isRequired, // supplied from Redux
  addGame: PropTypes.func.isRequired, // supplied from Redux
  removeGame: PropTypes.func.isRequired, // supplied from Redux
  removeAllGames: PropTypes.func.isRequired, // supplied from Redux
  teamSeasonGameSelection: PropTypes.object.isRequired, // supplied from Redux
};

const mapStateToProps = state => ({
  qlikAppId: getQlikAppId(state),
  getGamesValue: getGamesValue(state),
  games: state.games.games,
  teamSeasonGameSelection: state.teamSeasonGameSelection,
});

const mapDispatchToProps = {
  addGamesData,
  addGame,
  removeGame,
  removeAllGames,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GameFilter);
